module.exports = __webpack_public_path__ + "static/media/Giorgia-Graziani-Consulenze-chiusura.ed51c27f.png";